__turbopack_context__.v({
  "caret": "nativeshowmore-module-scss-module__PaGyTG__caret",
  "contentShowWrapper": "nativeshowmore-module-scss-module__PaGyTG__contentShowWrapper",
  "contentWrapper": "nativeshowmore-module-scss-module__PaGyTG__contentWrapper",
  "dropdownIcon": "nativeshowmore-module-scss-module__PaGyTG__dropdownIcon",
  "hideLabel": "nativeshowmore-module-scss-module__PaGyTG__hideLabel",
  "showLabel": "nativeshowmore-module-scss-module__PaGyTG__showLabel",
  "textTop": "nativeshowmore-module-scss-module__PaGyTG__textTop",
  "wrapper": "nativeshowmore-module-scss-module__PaGyTG__wrapper",
});
